import { useEffect, useId } from "react";

export function useFocusStepHeading(): string {
  const headingId = useId();

  useEffect(() => {
    document.getElementById(headingId)?.focus();
  }, [headingId]);

  return headingId;
}
